import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import Price from "../Misc/Price";
import SecurityDeposit from "../Misc/SecurityDeposit";
import GuaranteePriceField from "../Footer/GuaranteePriceField";

export default function CheckoutOverview() {
  const {
    currentStep,
    car,
    displaySecurityDeposit,
    order,
    strings,
  } = useContext(CarOrderingContext)

  const options = Object.values(order.configuration.settings).flat(2)
  const useDisplayGuaranteePrice = currentStep?.fields?.displayGuaranteePrice

  return (
    <div className='config-overview'>
      <div className='config-overview__image-container'>
        <div className='image-container'>
          <img
            data-object-fit='contain'
            src={car.imageUrl}
            alt={'Bil'}
          />
        </div>
      </div>

      <div className='config-overview__car-details'>
        <h2 className='config-overview__car-title'>{currentStep.title}</h2>
        <p className='config-overview__car-color'>{currentStep.subtitle}</p>

        <div
          className='overview'
          dangerouslySetInnerHTML={{ __html: currentStep.description ?? '' }}
        />
      </div>

      <div className='config-overview__overview'>
        <div className='config-overview__overview-title'>
          <div>
            {strings.misc.overview}
            <div className='config-tooltip'/>
          </div>
        </div>
        <div className='config-overview__prices'>
          <div className='config-overview__price'>
            <div>{car.title}</div>
            <div>
              <div className='config-overview__price-price'>
                <Price price={car.price}/>
              </div>
            </div>
          </div>

          {options.map((option, index) => (
            <div key={index} className='config-overview__price'>
              <div>{option?.title ?? option.name}</div>
              <div>
                <div className='config-overview__price-price'>
                  <Price price={option.price}/>
                </div>
              </div>
            </div>
          ))}
        </div>

        {
          displaySecurityDeposit && (
            <div className='config-overview__title'>
              <div>{strings.price.securityDeposit}</div>
              <div>
                <SecurityDeposit/>
              </div>
            </div>
          )
        }

        {useDisplayGuaranteePrice && (<GuaranteePriceField/>)}

        <div className='config-overview__title'>
          <div>
            {strings.price.total}
          </div>
          <div className='fit-content'>
            <Price classname='price total' price={order.price}/>
            <span>{strings.price.inclVat}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
